<div class="flex-column">
    <mat-card [ngClass]="'card-shadow'">
        <mat-card-header class="mbs-4">
            <mat-card-title>Agenda</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mx-2 mb-3">
            <div class="flex-row align-center-start">
                    <mat-card class="mbs-3 mx-1 flex-40">
                    <app-filter
                        [getAgreementsByProvider]="this.getAgreementsByProvider"
                        [preselectProviderId]="providerId"
                        (onLoadScheduleWithDataFilter)="this.onLoadScheduleExtended($event)"
                        (onLoadSchedule)="this.onLoadSchedule($event, this.globalRequestsParams.fromDate, globalRequestsParams.toDate)"
                        (cases)="this.casesFilteredByProvider = $event">
                    </app-filter>
                    </mat-card>
                        <mat-card class="mbs-3 mx-1 flex-60">
                            <app-schedule-case
                                class="flex-100"
                                [cases]="casesFilteredByProvider"
                                [attentions]="this.attentions"
                                [viewColumnsBillAndDebit]="this.viewColumnsBillAndDebit"
                                [selectedOption]="this.selectedOption"
                                [optionViewSelected]="calculateView()"
                                [provisionsFilteredCount]="this.provisionsFilteredCount"
                                [provisionsSuppliesFilteredCount]="this.provisionsSuppliesFilteredCount"
                                [ordersFilteredCount]="this.ordersFilteredCount"
                                (agreementNewAttention)="this.receiveAgreementOfNewAttention($event)"
                                (refreshDataFiltered)="this.refreshViewFiltered()"
                                [provisionAgreements]="!!this.provisionAgreementsFilters?.agreements ? this.provisionAgreementsFilters.agreements : []"
                                (openModifySuppliesProvisionFee)="this.openModifyProvisionFeeSupplies($event)"
                                [billSuppliesExternally]="billModifiedSupplies"
                                [allProvisionsWithoutFilter]="this.allProvisionsWithoutFilter"
                                [provisionsFromAgreements]="this.agreementsProvisions"
                                [fromProviderSchedule]='true'>
                            </app-schedule-case>
                        </mat-card>
            </div>
        </mat-card-content>
    </mat-card>
</div>

<ng-template #dateFormDiv>
    <div class="flex-row flex-wrap gap-10">
        <!-- Fecha INICIO -->
        <!-- <app-date-picker *ngIf="!!this.agreementSelected" class="flex-auto"
            [name]="this.DATE_FROM"
            [disabled]="this.activeAttention.state.id != ATTENTION_STATES.AGENDADA" [form]="this.scheduleForm"
            [placeholder]="'Inicio de la atención'">
        </app-date-picker> -->
        <!-- Fecha y hora FIN -->
        <!-- <app-date-picker
            *ngIf="!!this.agreementSelected && this.agreementSelected.provision.practice.restriction.requiredToDate"
            [disabled]="this.activeAttention.state.id != ATTENTION_STATES.AGENDADA" class="flex-auto"
             [name]="this.DATE_TO" [form]="this.scheduleForm"
            [placeholder]="'Finalización de la atención'">
        </app-date-picker> -->
        <!-- Fecha FIN No existe este caso -->
    </div>
</ng-template>

<ng-template #loadingRequest>
    <div class="flex-100 mts-5 align-center-center">
        <app-spinner *ngIf="!this.error; else errorDiv" class="flex-100 center-start"></app-spinner>
    </div>
</ng-template>

<ng-template #loadingConfirm>
    <mat-icon>
        <mat-spinner color="accent" diameter="20">
        </mat-spinner>
    </mat-icon>
</ng-template>

<ng-template #errorDiv>
    <div class="flex-100 align-center-center">
        <app-spinner-error></app-spinner-error>
        <span>
            Ha ocurrido un error inesperado, inténtelo nuevamente
        </span>
    </div>
</ng-template>
